/* Fresca — Why choose: phone swipe row (dots + active card) and stats band count-up.
   Without JS the feature row still scrolls/snaps natively and every card is visible. */
(() => {
  const reduced = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ---------- Feature swipe row (phones) ---------- */
  const initRail = (sec) => {
    const track = sec.querySelector('[data-why-track]');
    if (!track || track.dataset.ready) return;
    track.dataset.ready = '1';
    const cards = [...track.children];
    const dots = [...sec.querySelectorAll('[data-why-dot]')];
    if (!cards.length) return;

    const isCarousel = () => getComputedStyle(track).overflowX !== 'visible' && track.scrollWidth > track.clientWidth + 4;
    const pad = () => parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
    let active = -1;
    const setActive = (i) => {
      if (i === active) return;
      active = i;
      cards.forEach((c, j) => c.classList.toggle('is-active', j === i));
      dots.forEach((d, j) => d.setAttribute('aria-current', String(j === i)));
    };
    const nearest = () => {
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) return cards.length - 1;
      const x = track.scrollLeft + pad();
      let best = 0, dist = Infinity;
      cards.forEach((c, i) => { const d = Math.abs(c.offsetLeft - x); if (d < dist) { dist = d; best = i; } });
      return best;
    };
    const go = (i) => {
      const c = cards[i];
      if (!c) return;
      if (isCarousel()) track.scrollTo({ left: c.offsetLeft - pad(), behavior: reduced ? 'auto' : 'smooth' });
      setActive(i);
    };
    const sync = () => {
      const on = isCarousel();
      track.classList.toggle('is-carousel', on);
      if (on) { active = -1; setActive(nearest()); }
      else { active = -1; cards.forEach((c) => c.classList.remove('is-active')); }
    };

    let raf = 0;
    track.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(() => { raf = 0; if (track.classList.contains('is-carousel')) setActive(nearest()); });
    }, { passive: true });
    dots.forEach((d) => d.addEventListener('click', () => go(Number(d.dataset.whyDot))));
    sec.addEventListener('shopify:block:select', (e) => { const i = cards.indexOf(e.target); if (i > -1) go(i); });
    let rt = 0;
    addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(sync, 120); }, { passive: true });
    sync();

    // Strip entrance (phones only): cards slide in from the right as one staggered row.
    // Armed only here, so if this script never runs nothing is ever hidden.
    if (!reduced && 'IntersectionObserver' in window && isCarousel()) {
      const r = track.getBoundingClientRect();
      if (r.top > innerHeight * 0.9) {
        track.classList.add('is-armed');
        const io = new IntersectionObserver(([en]) => {
          if (!en.isIntersecting) return;
          io.disconnect();
          track.classList.add('is-in');
        }, { threshold: 0.2 });
        io.observe(track);
      }
    }
  };

  /* ---------- Stats band count-up ----------
     The real numbers are in the markup (so they show without JS / with reduced motion); they are only
     zeroed once we know we can animate them, and each figure keeps its final width so nothing shifts. */
  const ease = (t) => 1 - Math.pow(1 - t, 4);
  const initStats = (band) => {
    if (band.dataset.ready || reduced || !('IntersectionObserver' in window)) return;
    band.dataset.ready = '1';
    const items = [...band.querySelectorAll('[data-why-count]')].map((el) => {
      const raw = (el.dataset.whyCount || '').trim();
      if (!/^\d+(\.\d+)?$/.test(raw)) return null;
      return { el, raw, end: parseFloat(raw), dec: (raw.split('.')[1] || '').length, fig: el.closest('.fr-stat__fig') || el };
    }).filter(Boolean);
    if (!items.length) return;

    items.forEach((it) => {
      it.fig.style.minWidth = Math.ceil(it.fig.getBoundingClientRect().width) + 'px';
      it.el.textContent = (0).toFixed(it.dec);
    });

    const run = () => items.forEach((it, i) => {
      const dur = 1900, delay = i * 120;
      let t0 = null;
      const tick = (t) => {
        if (t0 === null) t0 = t + delay;
        const p = Math.min(1, Math.max(0, (t - t0) / dur));
        it.el.textContent = p >= 1 ? it.raw : (it.end * ease(p)).toFixed(it.dec);
        if (p < 1) requestAnimationFrame(tick);
        else it.fig.style.minWidth = '';
      };
      requestAnimationFrame(tick);
    });

    const io = new IntersectionObserver((entries) => {
      if (!entries.some((e) => e.isIntersecting)) return;
      io.disconnect();
      run();
    }, { threshold: 0.35 });
    io.observe(band);
  };

  const boot = (root) => {
    root.querySelectorAll('.fr-why').forEach(initRail);
    const bands = root.querySelectorAll('.fr-why .fr-stats');
    const go = () => bands.forEach(initStats);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(go, go);
    else go();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
  else boot(document);
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
